export default [

     {
          path: '/period',
          name: 'Period',
          component: () => import("@/views/Page/Period/Period.vue"),
          meta: {
               title: 'Period',
          },
     }
];